var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plus_card_div"},_vm._l((_vm.all_plus),function(data,index){return _c('Card',{key:index,staticClass:"ujoy_plus_card",attrs:{"data":data}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }